import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__dash",
  "use": "general__dash-usage",
  "viewBox": "0 0 30 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 30 6\" id=\"general__dash\">\n  <line stroke-linecap=\"round\" stroke-width=\"4\" x1=\"2\" y1=\"3\" x2=\"28\" y2=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol